let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5PqJ2")).then(() => parcelRequire('c05fi'));